import React from 'react';
export var ReactReduxContext = /*#__PURE__*/React.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

export default ReactReduxContext;


//////////////////
// WEBPACK FOOTER
// ../~/react-redux/es/components/Context.js
// module id = 288
// module chunks = 121